import { render, staticRenderFns } from "./assignCoaches.vue?vue&type=template&id=1f229674"
import script from "./assignCoaches.vue?vue&type=script&lang=js"
export * from "./assignCoaches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports